<template>
  <div>
    <div
      id="adbox"
      ref="adbox"
      v-show="showAdbox"
      @mouseenter="enterbox"
      @mouseleave="leavebox"
    >
      <a href="javascript:;">
        <img src="../../assets/image/piaochuang/pc.png" />
      </a>
      <b @click="closebox">×</b>
    </div>
  </div>
</template> 
<style scoped>
#adbox {
  width: 130px;
  height: 130px;
  position: fixed;
  z-index: 99999;
}
#adbox img {
  border: none;
  width: 150px;
  height: 150px;
}
#adbox b {
  position: absolute;
  right: -10px;
  top: 0;
  cursor: pointer;
  color: #666;
}
</style>
<script>
export default {
  data() {
    return {
      x: 50,
      y: 50,
      xin: true,
      yin: true,
      step: 1,
      delay: 20,
      itl: null,
      showAdbox: true,
      offsetWidth: 150,
      offsetHeight: 150,
    };
  },

  methods: {
    closebox() {
      this.showAdbox = false;
      clearInterval(this.itl);
    },
    leavebox() {
      if (this.showAdbox == false) {
        clearInterval(this.itl);
      } else {
        this.itl = setInterval(this.movebox, this.delay);
      }
    },
    enterbox() {
      clearInterval(this.itl);
    },
    movebox() {
      var L = 0;
      var T = 0;
      var R = document.documentElement.clientWidth - this.offsetWidth; //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
      var B = document.documentElement.clientHeight - this.offsetHeight; //浏览器显示高度-adbox高度，不随滚动条变化而变化
      this.$refs.adbox.style.left =this.x + document.documentElement.scrollLeft + "px"; 
      //adbox初始左+滚动条最左端到浏览器最左端的距离
      this.$refs.adbox.style.top =
        this.y + document.documentElement.scrollTop + "px"; //adbox初始高+滚动条顶端到浏览器顶端的距离
      this.x = this.x + this.step * (this.xin ? 1 : -1);
      if (this.x < L) {
        this.xin = true;
        this.x = L;
      }
      if (this.x > R) {
        this.xin = false;
        this.x = R;
      }
      this.y = this.y + this.step * (this.yin ? 1 : -1);
      if (this.y < T) {
        this.yin = true;
        this.y = T;
      }
      if (this.y > B) {
        this.yin = false;
        this.y = B;
      }
    },
    routeEnterShowAdbox() {
      this.itl = setInterval(this.movebox, this.delay);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/index_parent/piaochuang.vue